"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_NOT_SUBMITTED = exports.STATUS_NOT_SELECTED = exports.STATUS_INITIATED = exports.STATUS_INELIGIBLE = exports.STATUS_FINAL_FINANCIAL_RECONCILIATION = exports.STATUS_EXPIRED = exports.STATUS_DISAPPROVED_BY_RECIPIENT = exports.STATUS_DISAPPROVED = exports.STATUS_DENIED = exports.STATUS_CLOSEOUT_INITIATED = exports.STATUS_CLOSED = exports.STATUS_CANCELLED = exports.STATUS_AWARD_RESCINDED = exports.STATUS_AWARD_OFFER_EXPIRED = exports.STATUS_AWARD_OFFERED = exports.STATUS_AWARD_DECLINED = exports.STATUS_AWARD_ACCEPTED = exports.STATUS_AWARDED = exports.STATUS_APPROVED_BY_RECIPIENT = exports.STATUS_APPROVED = exports.STATUS_AMENDMENT_WITHDRAWN = exports.STATUS_AMENDMENT_INITIATED = exports.STATUS_AMENDMENT_DENIED = exports.STATUS_AMENDMENT_CANCELLED = exports.STATUS_AMENDMENT_APPROVED = exports.STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED = exports.STATUS_ADMINISTRATIVELY_CLOSED = exports.STATUS_ACCEPTED = exports.SHOW_HIDE = exports.SECTION_RESULTS = exports.SCORE = exports.ROLE_MAP = exports.REQUEST_DETAILS_VALUE_CHANGE_FORMAT = exports.REQUEST_DETAILS_VALUE_CHANGE_DISPLAY = exports.REQUEST_DETAILS_CHANGES_TYPES = exports.REMOVED = exports.RECRUITMENT_AND_RETENTION = exports.PROGRAM_TYPE_PASSTHROUGH = exports.PROGRAM_TYPE_DIRECT = exports.PREVIOUS_TERMS_AND_CONDITIONS = exports.PREAWARD_STATUSES = exports.PART_RESULTS = exports.PANEL_STATUS_CHANGE_DISPLAY = exports.ORG_REL_TYPE_MAP = exports.NUM_ACTIONS_TO_SHOW = exports.NONSUBRECIPENT_ROLES_LABEL = exports.MONTH_NAMES = exports.MOMENT_EST = exports.MITIGATION_PLAN_TYPES_STANDARD_ENHANCED = exports.MITIGATION_PLAN_TYPES = exports.MAILING_ADDRESS = exports.JUSTIFICATION = exports.IA_PROGRAMS = exports.HOLIDAYS = exports.HMA_PROGRAMS = exports.HISTORY_TYPES = exports.HIRING_OF_FIREFIGHTERS = exports.GRANT_ROSTER_FIELDS = exports.GRANT_ACTIONS_REQUIRED_TOGGLES = exports.GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC = exports.GRANTS_LANDING_PAGE_NAV_ITEMS = exports.FACTOR_RESULTS = exports.EXCLUDED_ROLES = exports.ERROR = exports.ENTITY_PAGE_TYPE_SUBGRANT = exports.ENTITY_PAGE_TYPE_SUBAPPLICATION = exports.ENTITY_PAGE_TYPE_GRANT = exports.ENTITY_PAGE_TYPE_FUNDINGOPPORTUNITY = exports.ENTITY_MAP = exports.EHP_WITHDRAWN = exports.EHP_SUSPENDED = exports.EHP_SUBMITTED = exports.EHP_PENDING = exports.EHP_NOT_APPROVED = exports.EHP_IN_RFI = exports.EHP_IN_PROGRESS = exports.EHP_DENIED = exports.EHP_APPROVED = exports.COOKIES = exports.COMMENT_TYPE = exports.CAN_SUBMIT_POSITIVE = exports.CAN_SUBMIT = exports.BOCS = exports.BEFORE_FINAL_SUBMISSION_STATUSES = exports.BANKING_PERMISSION_ROLES = exports.AUTHORIZED_VIEW_SUB_APP_ROLES = exports.AUTHORIZED_SUBRECIPIENT_ROLES = exports.AUTHORIZED_ROLES_V2 = exports.AUTHORIZED_ROLES = exports.AUTHORIZED_PANEL_REVIEW_ROLES = exports.ATTACHMENT_TYPES = exports.ASSOCIATED_PAYMENT_STATUSES = exports.ASSOCIATED_ENTITY_STATUSES = exports.ASSOCIATED_AMENDMENT_STATUSES = exports.APPLICATION_SUBMITTED_FOR_SELF = exports.APPLICATION_SUBMITTED_FOR_APPLICANT = exports.ALWAYS_DIRTY_MAP = exports.ACTIVITY_RESPONSES = exports.ACCEPTED_FILE_TYPES = exports.ACCEPTED_FILE_SIZE = void 0;
exports.profilePhoneNumberOptions = exports.phoneNumberOptions = exports.history = exports.email_regex = exports.activityTier = exports.YES_NO_RADIO_OPTIONS = exports.UNIT_OF_MEASURE_TYPES = exports.TOKEN_LOADING = exports.TOKEN_LOADED = exports.TOGGLE_SUCCESS = exports.TOGGLE_REDUX_PATH = exports.TOGGLE_LOADING = exports.TOGGLE_ERROR = exports.TERMS_AND_CONDITIONS_TYPES = exports.SUB_AWARD_REC_INDX_ERROR = exports.SUBRECIPIENT_ROLES_LABEL = exports.SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT = exports.SUBGRANTS_LANDING_PAGE_NAV_ITEMS = exports.STATUS_WITHDRAWN = exports.STATUS_SUBMITTED_TO_RECIPIENT = exports.STATUS_SUBMITTED_TO_FEMA = exports.STATUS_SUBGRANT_FINANCIAL_RECONCILIATION = exports.STATUS_SUBAWARD_RESCINDED = exports.STATUS_SUBAWARD_OFFER_EXPIRED = exports.STATUS_SUBAWARD_OFFERED = exports.STATUS_SUBAWARD_DECLINED = exports.STATUS_SUBAWARD_ACCEPTED = exports.STATUS_STOCKPILE = exports.STATUS_SAVED_FOR_LATER = exports.STATUS_ROF_PROCESSING = exports.STATUS_ROF_PROCESSED = exports.STATUS_REVIEW_COMPLETED = exports.STATUS_RETURNED_TO_SUBRECIPIENT = exports.STATUS_RETURNED_TO_RECIPIENT = exports.STATUS_PROCESSING = exports.STATUS_PROCESSED = exports.STATUS_PENDING_SUBMISSION = exports.STATUS_PENDING_SAR_SIGNATURE = exports.STATUS_PENDING_AOR_SUBMISSION = exports.STATUS_PENDING_AOR_SIGNATURE = exports.STATUS_PAYMENT_WITHDRAWN = exports.STATUS_PAYMENT_DENIED = exports.STATUS_PAYMENT_APPROVED = exports.STATUS_PARTIALLY_APPROVED = exports.STATUS_NOT_SUBMITTED_MISSING = void 0;
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.number.constructor.js");
var _history = require("history");
var _PREAWARD_STATUSES, _ASSOCIATED_ENTITY_ST;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var history = (0, _history.createBrowserHistory)();
exports.history = history;
var ENTITY_MAP = {
  ORGANIZATION: {
    code: '1',
    label: 'Organization'
  },
  PROGRAM: {
    code: '2',
    label: 'Program'
  },
  SYSTEM: {
    code: '3',
    label: 'System'
  },
  PANEL_REVIEW: {
    code: '4',
    label: 'Panel Review'
  },
  PROGRAM_ORGANIZATION: {
    code: '5',
    label: 'Program Organization'
  },
  PROGRAM_ORGANIZATION_SUBORGANIZATION: {
    code: '6',
    label: 'Program Organization Suborganization'
  },
  PROGRAM_EXTERNAL: {
    code: '7',
    label: 'Program External'
  },
  REPORT_CATEGORY: {
    code: '8',
    label: 'Report Category'
  },
  FEMA_ORGANIZATION: {
    code: '9',
    label: 'Organization'
  },
  FUNDING_OPPORTUNITY: {
    code: '10',
    label: 'Funding Opportunity'
  },
  FEMA_SYSTEM: {
    code: '11',
    label: 'System'
  }
};
exports.ENTITY_MAP = ENTITY_MAP;
var HMA_PROGRAMS = {
  PDM: {
    code: '13',
    label: 'Pre-Disaster Mitigation'
  },
  FMA: {
    code: '14',
    label: 'Flood Mitigation Assistance'
  },
  BRIC: {
    code: '15',
    label: 'Building Resilient Infrastructure and Communities'
  },
  HMGP: {
    code: '16',
    label: 'Hazard Mitigation Grant Program'
  },
  HMPF: {
    code: '17',
    label: 'Hazard Mitigation Post-Fire'
  }
};
exports.HMA_PROGRAMS = HMA_PROGRAMS;
var IA_PROGRAMS = {
  DCM: {
    code: '18',
    label: 'Disaster Case Management'
  }
};
exports.IA_PROGRAMS = IA_PROGRAMS;
var ROLE_MAP = {
  ORGAOR: {
    code: '1',
    label: 'Authorized Organization Representative'
  },
  ORGMEMBER: {
    code: '2',
    label: 'Organization Member'
  },
  PGMADMIN: {
    code: '3',
    label: 'Program Administrator'
  },
  PGMGMS: {
    code: '4',
    label: 'Grants Management Specialist'
  },
  PGMAO: {
    code: '5',
    label: 'Assistance Officer'
  },
  PGMPS: {
    code: '6',
    label: 'Program Specialist'
  },
  SYSTEMADMIN: {
    code: '7',
    label: 'System Admininstrator'
  },
  ASA: {
    code: '8',
    label: 'Authorized Signature Authority'
  },
  OCC: {
    code: '9',
    label: 'Grants Counsel'
  },
  PR: {
    code: '10',
    label: 'Panel Reviewer'
  },
  PC: {
    code: '11',
    label: 'Panel Chair'
  },
  PRC: {
    code: '12',
    label: 'Panel Review Coordinator'
  },
  EHPADMIN: {
    code: '13',
    label: 'EHP Administrator'
  },
  EHPREVIEWER: {
    code: '14',
    label: 'EHP Reviewer'
  },
  GCS: {
    code: '15',
    label: 'Grants Counsel Staff'
  },
  GCA: {
    code: '16',
    label: 'Grants Counsel Admininstrator'
  },
  ORGPGMMEMBER: {
    code: '17',
    label: 'Programmatic Member'
  },
  ORGFINMEMBER: {
    code: '18',
    label: 'Financial Member'
  },
  ORGGRNTWRITER: {
    code: '19',
    label: 'Grant Writer'
  },
  SUBMEMBER: {
    code: '20',
    label: 'Subrecipient Member'
  },
  SUBAUTHREP: {
    code: '21',
    label: 'Subrecipient Authorized Representative'
  },
  PANELADMIN: {
    code: '23',
    label: 'Panel Admininstrator'
  },
  NTRREVIEWER: {
    code: '24',
    label: 'National Technical Reviewer'
  },
  ANALYTICSUSER: {
    code: '25',
    label: 'Analytics User'
  },
  ANALYTICSADMIN: {
    code: '26',
    label: 'Analytics Admin'
  },
  SPGMADMIN: {
    code: '28',
    label: 'Senior Program Administrator'
  },
  SMA: {
    code: '42',
    label: 'Service Management Administrator'
  },
  SMU: {
    code: '44',
    label: 'Service Management User'
  },
  SAO: {
    code: '46',
    label: 'Senior Assistance Officer'
  },
  SRANALYTICSADMIN: {
    code: '49',
    label: 'Senior Analytics Admin'
  },
  READONLY: {
    code: '61',
    label: 'Read Only'
  }
};
exports.ROLE_MAP = ROLE_MAP;
var ORG_REL_TYPE_MAP = {
  PARENT_ORGANIZATION: {
    code: '1',
    label: 'Parent organization'
  },
  SUBORGANZATION: {
    code: '2',
    label: 'Suborganization'
  },
  NOT_PARENT_ORG_OR_SUBORG: {
    code: '3',
    label: 'Neither parent nor suborganization'
  },
  PARENT_ORG_AND_SUBORG: {
    code: '4',
    label: 'Parent organization and suborganization'
  }
};
exports.ORG_REL_TYPE_MAP = ORG_REL_TYPE_MAP;
var BANKING_PERMISSION_ROLES = ['3', '4', '5'];
exports.BANKING_PERMISSION_ROLES = BANKING_PERMISSION_ROLES;
var COMMENT_TYPE = {
  EXTERNAL: 'External comments',
  INTERNAL: 'Internal FEMA comments'
};
exports.COMMENT_TYPE = COMMENT_TYPE;
var ENTITY_PAGE_TYPE_GRANT = 'grant';
exports.ENTITY_PAGE_TYPE_GRANT = ENTITY_PAGE_TYPE_GRANT;
var ENTITY_PAGE_TYPE_SUBGRANT = 'subGrant';
exports.ENTITY_PAGE_TYPE_SUBGRANT = ENTITY_PAGE_TYPE_SUBGRANT;
var ENTITY_PAGE_TYPE_SUBAPPLICATION = 'subApplication';
exports.ENTITY_PAGE_TYPE_SUBAPPLICATION = ENTITY_PAGE_TYPE_SUBAPPLICATION;
var ENTITY_PAGE_TYPE_FUNDINGOPPORTUNITY = 'fundingOpportunity';
exports.ENTITY_PAGE_TYPE_FUNDINGOPPORTUNITY = ENTITY_PAGE_TYPE_FUNDINGOPPORTUNITY;
var AUTHORIZED_ROLES = [ROLE_MAP.GCA.code, ROLE_MAP.ORGAOR.code, ROLE_MAP.PGMADMIN.code, ROLE_MAP.PGMAO.code, ROLE_MAP.EHPADMIN.code, ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SPGMADMIN.code, ROLE_MAP.ANALYTICSADMIN.code];
exports.AUTHORIZED_ROLES = AUTHORIZED_ROLES;
var AUTHORIZED_ROLES_V2 = [ROLE_MAP.GCA.code, ROLE_MAP.ORGAOR.code, ROLE_MAP.PGMADMIN.code, ROLE_MAP.PGMAO.code, ROLE_MAP.EHPADMIN.code, ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.PANELADMIN.code, ROLE_MAP.SPGMADMIN.code, ROLE_MAP.ANALYTICSADMIN.code];
exports.AUTHORIZED_ROLES_V2 = AUTHORIZED_ROLES_V2;
var AUTHORIZED_VIEW_SUB_APP_ROLES = [ROLE_MAP.ORGAOR.code, ROLE_MAP.ORGMEMBER.code, ROLE_MAP.ORGPGMMEMBER.code, ROLE_MAP.ORGFINMEMBER.code, ROLE_MAP.ORGGRNTWRITER.code];
exports.AUTHORIZED_VIEW_SUB_APP_ROLES = AUTHORIZED_VIEW_SUB_APP_ROLES;
var AUTHORIZED_SUBRECIPIENT_ROLES = [ROLE_MAP.SUBMEMBER.code, ROLE_MAP.SUBAUTHREP.code];
exports.AUTHORIZED_SUBRECIPIENT_ROLES = AUTHORIZED_SUBRECIPIENT_ROLES;
var SUBRECIPIENT_ROLES_LABEL = [ROLE_MAP.SUBMEMBER.label, ROLE_MAP.SUBAUTHREP.label];
exports.SUBRECIPIENT_ROLES_LABEL = SUBRECIPIENT_ROLES_LABEL;
var NONSUBRECIPENT_ROLES_LABEL = [ROLE_MAP.ORGAOR.label, ROLE_MAP.ORGMEMBER.label, ROLE_MAP.ORGPGMMEMBER.label, ROLE_MAP.ORGFINMEMBER.label, ROLE_MAP.ORGGRNTWRITER.label];
exports.NONSUBRECIPENT_ROLES_LABEL = NONSUBRECIPENT_ROLES_LABEL;
var AUTHORIZED_PANEL_REVIEW_ROLES = [ROLE_MAP.PR.code, ROLE_MAP.PC.code];
exports.AUTHORIZED_PANEL_REVIEW_ROLES = AUTHORIZED_PANEL_REVIEW_ROLES;
var EXCLUDED_ROLES = [ROLE_MAP.PC.code];
exports.EXCLUDED_ROLES = EXCLUDED_ROLES;
var STATUS_SUBMITTED_TO_FEMA = 'submittedToFEMA';
exports.STATUS_SUBMITTED_TO_FEMA = STATUS_SUBMITTED_TO_FEMA;
var STATUS_CLOSEOUT_INITIATED = 'closeoutInitiated';
exports.STATUS_CLOSEOUT_INITIATED = STATUS_CLOSEOUT_INITIATED;
var STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED = 'administrativeCloseoutInitiated';
exports.STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED = STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED;
var STATUS_ADMINISTRATIVELY_CLOSED = 'administrativelyClosed';
exports.STATUS_ADMINISTRATIVELY_CLOSED = STATUS_ADMINISTRATIVELY_CLOSED;
var STATUS_FINAL_FINANCIAL_RECONCILIATION = 'finalFinancialReconciliation';
exports.STATUS_FINAL_FINANCIAL_RECONCILIATION = STATUS_FINAL_FINANCIAL_RECONCILIATION;
var STATUS_SUBGRANT_FINANCIAL_RECONCILIATION = 'subgrantFinancialReconciliation';
exports.STATUS_SUBGRANT_FINANCIAL_RECONCILIATION = STATUS_SUBGRANT_FINANCIAL_RECONCILIATION;
var STATUS_CLOSED = 'closed';
exports.STATUS_CLOSED = STATUS_CLOSED;
var STATUS_AWARD_OFFERED = 'awardOffered';
exports.STATUS_AWARD_OFFERED = STATUS_AWARD_OFFERED;
var STATUS_SUBAWARD_OFFERED = 'subAwardOffered';
exports.STATUS_SUBAWARD_OFFERED = STATUS_SUBAWARD_OFFERED;
var STATUS_AWARD_ACCEPTED = 'awardAccepted';
exports.STATUS_AWARD_ACCEPTED = STATUS_AWARD_ACCEPTED;
var STATUS_SUBAWARD_ACCEPTED = 'subAwardAccepted';
exports.STATUS_SUBAWARD_ACCEPTED = STATUS_SUBAWARD_ACCEPTED;
var STATUS_SUBAWARD_DECLINED = 'subAwardDeclined';
exports.STATUS_SUBAWARD_DECLINED = STATUS_SUBAWARD_DECLINED;
var STATUS_AWARDED = 'awarded';
exports.STATUS_AWARDED = STATUS_AWARDED;
var STATUS_AWARD_DECLINED = 'awardDeclined';
exports.STATUS_AWARD_DECLINED = STATUS_AWARD_DECLINED;
var STATUS_AWARD_RESCINDED = 'awardRescinded';
exports.STATUS_AWARD_RESCINDED = STATUS_AWARD_RESCINDED;
var STATUS_SUBAWARD_RESCINDED = 'subAwardRescinded';
exports.STATUS_SUBAWARD_RESCINDED = STATUS_SUBAWARD_RESCINDED;
var STATUS_AWARD_OFFER_EXPIRED = 'awardOfferExpired';
exports.STATUS_AWARD_OFFER_EXPIRED = STATUS_AWARD_OFFER_EXPIRED;
var STATUS_SUBAWARD_OFFER_EXPIRED = 'subAwardOfferExpired';
exports.STATUS_SUBAWARD_OFFER_EXPIRED = STATUS_SUBAWARD_OFFER_EXPIRED;
var STATUS_PENDING_SUBMISSION = 'pendingSubmission';
exports.STATUS_PENDING_SUBMISSION = STATUS_PENDING_SUBMISSION;
var STATUS_SUBMITTED_TO_RECIPIENT = 'submittedToRecipient';
exports.STATUS_SUBMITTED_TO_RECIPIENT = STATUS_SUBMITTED_TO_RECIPIENT;
var STATUS_PENDING_AOR_SIGNATURE = 'pendingAorSignature';
exports.STATUS_PENDING_AOR_SIGNATURE = STATUS_PENDING_AOR_SIGNATURE;
var STATUS_PENDING_SAR_SIGNATURE = 'pendingSarSignature';
exports.STATUS_PENDING_SAR_SIGNATURE = STATUS_PENDING_SAR_SIGNATURE;
var STATUS_RETURNED_TO_RECIPIENT = 'returnedToRecipient';
exports.STATUS_RETURNED_TO_RECIPIENT = STATUS_RETURNED_TO_RECIPIENT;
var STATUS_RETURNED_TO_SUBRECIPIENT = 'returnedToSubRecipient';
exports.STATUS_RETURNED_TO_SUBRECIPIENT = STATUS_RETURNED_TO_SUBRECIPIENT;
var STATUS_NOT_SUBMITTED = 'notSubmitted';
exports.STATUS_NOT_SUBMITTED = STATUS_NOT_SUBMITTED;
var STATUS_NOT_SUBMITTED_MISSING = 'notSubmittedMissing';
exports.STATUS_NOT_SUBMITTED_MISSING = STATUS_NOT_SUBMITTED_MISSING;
var STATUS_ACCEPTED = 'accepted';
exports.STATUS_ACCEPTED = STATUS_ACCEPTED;
var STATUS_NOT_SELECTED = 'notSelected';
exports.STATUS_NOT_SELECTED = STATUS_NOT_SELECTED;
var APPLICATION_SUBMITTED_FOR_SELF = 'self';
exports.APPLICATION_SUBMITTED_FOR_SELF = APPLICATION_SUBMITTED_FOR_SELF;
var APPLICATION_SUBMITTED_FOR_APPLICANT = 'applicant';
exports.APPLICATION_SUBMITTED_FOR_APPLICANT = APPLICATION_SUBMITTED_FOR_APPLICANT;
var STATUS_APPROVED_BY_RECIPIENT = 'approvedByRecipient';
exports.STATUS_APPROVED_BY_RECIPIENT = STATUS_APPROVED_BY_RECIPIENT;
var STATUS_DISAPPROVED_BY_RECIPIENT = 'disapprovedByRecipient';
exports.STATUS_DISAPPROVED_BY_RECIPIENT = STATUS_DISAPPROVED_BY_RECIPIENT;
var STATUS_INELIGIBLE = 'ineligible';
exports.STATUS_INELIGIBLE = STATUS_INELIGIBLE;
var STATUS_EXPIRED = 'expired';
exports.STATUS_EXPIRED = STATUS_EXPIRED;
var STATUS_REVIEW_COMPLETED = 'reviewCompleted';
exports.STATUS_REVIEW_COMPLETED = STATUS_REVIEW_COMPLETED;
var STATUS_SAVED_FOR_LATER = 'savedForLater';
exports.STATUS_SAVED_FOR_LATER = STATUS_SAVED_FOR_LATER;
var STATUS_PENDING_AOR_SUBMISSION = 'pendingAorSubmission';
exports.STATUS_PENDING_AOR_SUBMISSION = STATUS_PENDING_AOR_SUBMISSION;
var NUM_ACTIONS_TO_SHOW = 10;
exports.NUM_ACTIONS_TO_SHOW = NUM_ACTIONS_TO_SHOW;
var PREAWARD_STATUSES = (_PREAWARD_STATUSES = {}, _defineProperty(_PREAWARD_STATUSES, STATUS_SUBMITTED_TO_FEMA, 'Submitted to FEMA'), _defineProperty(_PREAWARD_STATUSES, STATUS_AWARD_OFFERED, 'Award offered'), _defineProperty(_PREAWARD_STATUSES, STATUS_SUBAWARD_OFFERED, 'Subaward offered'), _defineProperty(_PREAWARD_STATUSES, STATUS_AWARD_ACCEPTED, 'Award accepted'), _defineProperty(_PREAWARD_STATUSES, STATUS_SUBAWARD_ACCEPTED, 'Subaward accepted'), _defineProperty(_PREAWARD_STATUSES, STATUS_SUBAWARD_DECLINED, 'Subaward declined'), _defineProperty(_PREAWARD_STATUSES, STATUS_AWARD_DECLINED, 'Award declined'), _defineProperty(_PREAWARD_STATUSES, STATUS_AWARD_OFFER_EXPIRED, 'Award offer expired'), _defineProperty(_PREAWARD_STATUSES, STATUS_SUBAWARD_OFFER_EXPIRED, 'Subaward offer expired'), _defineProperty(_PREAWARD_STATUSES, STATUS_AWARD_RESCINDED, 'Award rescinded'), _defineProperty(_PREAWARD_STATUSES, STATUS_SUBAWARD_RESCINDED, 'Subaward rescinded'), _defineProperty(_PREAWARD_STATUSES, STATUS_NOT_SELECTED, 'Not selected'), _PREAWARD_STATUSES);
exports.PREAWARD_STATUSES = PREAWARD_STATUSES;
var STATUS_INITIATED = 'initiated';
exports.STATUS_INITIATED = STATUS_INITIATED;
var STATUS_APPROVED = 'approved';
exports.STATUS_APPROVED = STATUS_APPROVED;
var STATUS_PARTIALLY_APPROVED = 'partiallyApproved';
exports.STATUS_PARTIALLY_APPROVED = STATUS_PARTIALLY_APPROVED;
var STATUS_DISAPPROVED = 'disapproved';
exports.STATUS_DISAPPROVED = STATUS_DISAPPROVED;
var STATUS_STOCKPILE = 'stockpile';
exports.STATUS_STOCKPILE = STATUS_STOCKPILE;
var STATUS_DENIED = 'denied';
exports.STATUS_DENIED = STATUS_DENIED;
var STATUS_WITHDRAWN = 'withdrawn';
exports.STATUS_WITHDRAWN = STATUS_WITHDRAWN;
var STATUS_CANCELLED = 'cancelled';
exports.STATUS_CANCELLED = STATUS_CANCELLED;
var STATUS_PROCESSED = 'processed';
exports.STATUS_PROCESSED = STATUS_PROCESSED;
var STATUS_PROCESSING = 'processing';

// EHP statuses
exports.STATUS_PROCESSING = STATUS_PROCESSING;
var EHP_PENDING = 'PENDING';
exports.EHP_PENDING = EHP_PENDING;
var EHP_SUBMITTED = 'SUBMITTED';
exports.EHP_SUBMITTED = EHP_SUBMITTED;
var EHP_IN_PROGRESS = 'IN_PROGRESS';
exports.EHP_IN_PROGRESS = EHP_IN_PROGRESS;
var EHP_IN_RFI = 'IN_RFI';
exports.EHP_IN_RFI = EHP_IN_RFI;
var EHP_SUSPENDED = '';
exports.EHP_SUSPENDED = EHP_SUSPENDED;
var EHP_WITHDRAWN = '';
exports.EHP_WITHDRAWN = EHP_WITHDRAWN;
var EHP_APPROVED = 'APPROVED';
exports.EHP_APPROVED = EHP_APPROVED;
var EHP_DENIED = 'DENIED';
exports.EHP_DENIED = EHP_DENIED;
var EHP_NOT_APPROVED = '';
exports.EHP_NOT_APPROVED = EHP_NOT_APPROVED;
var ASSOCIATED_ENTITY_STATUSES = (_ASSOCIATED_ENTITY_ST = {}, _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PENDING_SUBMISSION, 'Pending submission'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PENDING_AOR_SIGNATURE, 'Pending AOR signature'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PENDING_SAR_SIGNATURE, 'Pending SAR signature'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PENDING_AOR_SUBMISSION, 'Pending AOR submission'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBAWARD_ACCEPTED, 'Subaward accepted'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBAWARD_DECLINED, 'Subaward declined'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBAWARD_OFFERED, 'Subaward offered'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBAWARD_RESCINDED, 'Subaward rescinded'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBMITTED_TO_FEMA, 'Submitted to FEMA'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBMITTED_TO_RECIPIENT, 'Submitted to recipient'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_RETURNED_TO_RECIPIENT, 'Returned to recipient'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_RETURNED_TO_SUBRECIPIENT, 'Returned to subrecipient'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_APPROVED, 'Approved'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PARTIALLY_APPROVED, 'Partially approved'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_APPROVED_BY_RECIPIENT, 'Approved by recipient'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_DISAPPROVED, 'Disapproved'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_DISAPPROVED_BY_RECIPIENT, 'Disapproved by recipient'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_STOCKPILE, 'Stockpile'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SAVED_FOR_LATER, 'Saved for later'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_DENIED, 'Denied'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_WITHDRAWN, 'Withdrawn'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_NOT_SUBMITTED, 'Not submitted'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_NOT_SUBMITTED_MISSING, 'Not submitted - Missing'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_ACCEPTED, 'Accepted'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARD_OFFERED, 'Award offered'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARD_ACCEPTED, 'Award accepted'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARDED, 'Awarded'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_NOT_SELECTED, 'Not selected'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_INELIGIBLE, 'Ineligible'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_EXPIRED, 'Expired'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_REVIEW_COMPLETED, 'Review completed'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_INITIATED, 'Initiated'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_CANCELLED, 'Cancelled'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_CLOSEOUT_INITIATED, 'Closeout initiated'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_ADMINISTRATIVELY_CLOSED, 'Administratively closed'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_ADMINISTRATIVE_CLOSEOUT_INITIATED, 'Administrative closeout initiated'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_FINAL_FINANCIAL_RECONCILIATION, 'Final financial reconciliation'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_SUBGRANT_FINANCIAL_RECONCILIATION, 'Subgrant financial reconciliation'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_CLOSED, 'Closed'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARD_RESCINDED, 'Award rescinded'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARD_DECLINED, 'Award declined'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_AWARD_OFFER_EXPIRED, 'Award offer expired'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PROCESSING, 'Processing'), _defineProperty(_ASSOCIATED_ENTITY_ST, STATUS_PROCESSED, 'Processed'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_PENDING, 'Submitted to EMIS'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_SUBMITTED, 'Submitted to EMIS'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_IN_PROGRESS, 'Resubmitted to EMIS'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_IN_RFI, 'Request for rework'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_SUSPENDED, ''), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_WITHDRAWN, ''), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_APPROVED, 'Complete'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_DENIED, 'Complete'), _defineProperty(_ASSOCIATED_ENTITY_ST, EHP_NOT_APPROVED, ''), _ASSOCIATED_ENTITY_ST);
exports.ASSOCIATED_ENTITY_STATUSES = ASSOCIATED_ENTITY_STATUSES;
var BEFORE_FINAL_SUBMISSION_STATUSES = [STATUS_PENDING_SUBMISSION, STATUS_PENDING_AOR_SIGNATURE, STATUS_PENDING_SAR_SIGNATURE, STATUS_PENDING_AOR_SUBMISSION];

// Amendments
exports.BEFORE_FINAL_SUBMISSION_STATUSES = BEFORE_FINAL_SUBMISSION_STATUSES;
var STATUS_AMENDMENT_APPROVED = STATUS_APPROVED;
exports.STATUS_AMENDMENT_APPROVED = STATUS_AMENDMENT_APPROVED;
var STATUS_AMENDMENT_DENIED = STATUS_DENIED;
exports.STATUS_AMENDMENT_DENIED = STATUS_AMENDMENT_DENIED;
var STATUS_AMENDMENT_WITHDRAWN = STATUS_WITHDRAWN;
exports.STATUS_AMENDMENT_WITHDRAWN = STATUS_AMENDMENT_WITHDRAWN;
var STATUS_AMENDMENT_INITIATED = STATUS_INITIATED;
exports.STATUS_AMENDMENT_INITIATED = STATUS_AMENDMENT_INITIATED;
var STATUS_AMENDMENT_CANCELLED = STATUS_CANCELLED;
exports.STATUS_AMENDMENT_CANCELLED = STATUS_AMENDMENT_CANCELLED;
var ASSOCIATED_AMENDMENT_STATUSES = ASSOCIATED_ENTITY_STATUSES;

// Paymentsa
exports.ASSOCIATED_AMENDMENT_STATUSES = ASSOCIATED_AMENDMENT_STATUSES;
var STATUS_PAYMENT_APPROVED = STATUS_APPROVED;
exports.STATUS_PAYMENT_APPROVED = STATUS_PAYMENT_APPROVED;
var STATUS_PAYMENT_DENIED = STATUS_DENIED;
exports.STATUS_PAYMENT_DENIED = STATUS_PAYMENT_DENIED;
var STATUS_PAYMENT_WITHDRAWN = STATUS_WITHDRAWN;
exports.STATUS_PAYMENT_WITHDRAWN = STATUS_PAYMENT_WITHDRAWN;
var ASSOCIATED_PAYMENT_STATUSES = ASSOCIATED_ENTITY_STATUSES;

//Rof
exports.ASSOCIATED_PAYMENT_STATUSES = ASSOCIATED_PAYMENT_STATUSES;
var STATUS_ROF_PROCESSED = STATUS_PROCESSED;
exports.STATUS_ROF_PROCESSED = STATUS_ROF_PROCESSED;
var STATUS_ROF_PROCESSING = STATUS_PROCESSING;
exports.STATUS_ROF_PROCESSING = STATUS_ROF_PROCESSING;
var PROGRAM_TYPE_PASSTHROUGH = 'passthrough';
exports.PROGRAM_TYPE_PASSTHROUGH = PROGRAM_TYPE_PASSTHROUGH;
var PROGRAM_TYPE_DIRECT = 'direct';

// TODO refactor above to only have one status block for associated entities
exports.PROGRAM_TYPE_DIRECT = PROGRAM_TYPE_DIRECT;
var ACCEPTED_FILE_TYPES = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.jpg'];
exports.ACCEPTED_FILE_TYPES = ACCEPTED_FILE_TYPES;
var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
exports.MONTH_NAMES = MONTH_NAMES;
var MOMENT_EST = 'America/New_York';

// File Max Size 1074790400 Bytes (1GB)
exports.MOMENT_EST = MOMENT_EST;
var ACCEPTED_FILE_SIZE = 1074.79;
exports.ACCEPTED_FILE_SIZE = ACCEPTED_FILE_SIZE;
var ATTACHMENT_TYPES = ['Community Attachments', 'Mitigation Plan Attachments', 'Scope of Work Attachments', 'Budget Attachments', 'Evaluation Attachments'];

// in the order they should appear
exports.ATTACHMENT_TYPES = ATTACHMENT_TYPES;
var GRANTS_LANDING_PAGE_NAV_ITEMS = ['GrantSummary', 'Application', 'Attachment', 'Comments'];
exports.GRANTS_LANDING_PAGE_NAV_ITEMS = GRANTS_LANDING_PAGE_NAV_ITEMS;
var GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC = ['GrantSummary', 'Application', 'AwardRecommendation', 'Attachment', 'Comments'];

// in the order they should appear
exports.GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC = GRANTS_LANDING_PAGE_NAV_ITEMS_WITH_AWARDREC;
var SUBGRANTS_LANDING_PAGE_NAV_ITEMS = ['SubGrantSummary', 'SubApplication', 'SubAwardRecommendation', 'SubAttachment', 'SubComments'];
exports.SUBGRANTS_LANDING_PAGE_NAV_ITEMS = SUBGRANTS_LANDING_PAGE_NAV_ITEMS;
var SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT = ['SubGrantSummary', 'SubApplication', 'SubAwardRecommendation', 'SubGrant', 'SubAttachment', 'SubComments'];
exports.SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT = SUBGRANTS_LANDING_PAGE_NAV_ITEMS_WITH_SUBGRANT;
var HISTORY_TYPES = {
  NOTIFICATION: 'notificationSent'
};
exports.HISTORY_TYPES = HISTORY_TYPES;
var REQUEST_DETAILS_CHANGES_TYPES = {
  VALUE_CHANGE: 'valueChange',
  INELIGIBLE_CHANGE: 'ineligibleChange',
  NEWLY_CREATED: 'newlyCreated',
  VALUE_CHANGE_NO_DISPLAY: 'valueChangeNoDisplay'
};
exports.REQUEST_DETAILS_CHANGES_TYPES = REQUEST_DETAILS_CHANGES_TYPES;
var REQUEST_DETAILS_VALUE_CHANGE_DISPLAY = {
  description: 'Description',
  explainOtherItem: 'Other description',
  price: 'Unit price',
  quantity: 'Quantity',
  year: 'Year',
  item: 'Item',
  itemCode: 'Item',
  boc: 'Budget class',
  amount: 'Amount',
  costexplain: 'Benefits funded',
  annualSalary: 'Annual salary',
  annualBenefits: 'Annual benefits',
  measure: 'Unit of measure'
};
exports.REQUEST_DETAILS_VALUE_CHANGE_DISPLAY = REQUEST_DETAILS_VALUE_CHANGE_DISPLAY;
var PANEL_STATUS_CHANGE_DISPLAY = {
  notStarted: 'Not Started',
  panelReview: 'Panel Review',
  tableDiscussion: 'Table Discussion',
  panelChair: 'Panel Chair',
  complete: 'Completed'
};
exports.PANEL_STATUS_CHANGE_DISPLAY = PANEL_STATUS_CHANGE_DISPLAY;
var REQUEST_DETAILS_VALUE_CHANGE_FORMAT = {
  description: 'text',
  price: 'dollar',
  quantity: 'text',
  item: 'text',
  boc: 'text',
  amount: 'dollar',
  costexplain: 'text',
  annualSalary: 'dollar',
  annualBenefit: 'dollar',
  fullTimePosition: 'text'
};
exports.REQUEST_DETAILS_VALUE_CHANGE_FORMAT = REQUEST_DETAILS_VALUE_CHANGE_FORMAT;
var BOCS = {
  PERSONNEL: 'personnel',
  FRINGE_BENEFITS: 'fringeBenefits'
};
exports.BOCS = BOCS;
var TERMS_AND_CONDITIONS_TYPES = {
  SPECIAL: 'special',
  CUSTOM: 'custom',
  STANDARD: 'standard'
};
exports.TERMS_AND_CONDITIONS_TYPES = TERMS_AND_CONDITIONS_TYPES;
var REMOVED = 'removed';
exports.REMOVED = REMOVED;
var PREVIOUS_TERMS_AND_CONDITIONS = 'previousTermsAndConditions';
exports.PREVIOUS_TERMS_AND_CONDITIONS = PREVIOUS_TERMS_AND_CONDITIONS;
var MITIGATION_PLAN_TYPES_STANDARD_ENHANCED = ['State Multi-Hazard Mitigation Plan', 'Tribal Multi-Hazard Mitigation Plan'];
exports.MITIGATION_PLAN_TYPES_STANDARD_ENHANCED = MITIGATION_PLAN_TYPES_STANDARD_ENHANCED;
var MITIGATION_PLAN_TYPES = [{
  key: 'default',
  value: '',
  text: 'Select plan'
}, {
  key: 1,
  value: 'State Multi-Hazard Mitigation Plan',
  text: 'State Multi-Hazard Mitigation Plan'
}, {
  key: 2,
  value: 'Tribal Multi-Hazard Mitigation Plan',
  text: 'Tribal Multi-Hazard Mitigation Plan'
}, {
  key: 3,
  value: 'Local Multi-Hazard Mitigation Plan',
  text: 'Local Multi-Hazard Mitigation Plan'
}, {
  key: 4,
  value: 'Tribal (Local) Multi-Hazard Mitigation Plan',
  text: 'Tribal (Local) Multi-Hazard Mitigation Plan'
}, {
  key: 5,
  value: 'Local Multijurisdictional Multi-Hazard Mitigation Plan',
  text: 'Local Multijurisdictional Multi-Hazard Mitigation Plan'
}, {
  key: 6,
  value: 'Tribal (Local) Multijurisdictional Multi-Hazard Mitigation Plan',
  text: 'Tribal (Local) Multijurisdictional Multi-Hazard Mitigation Plan'
}];
exports.MITIGATION_PLAN_TYPES = MITIGATION_PLAN_TYPES;
var UNIT_OF_MEASURE_TYPES = [{
  key: 'default',
  value: '',
  text: 'Select Units'
}, {
  key: 1,
  value: 'Acre',
  text: 'Acre'
}, {
  key: 2,
  value: 'Cubic Foot',
  text: 'Cubic Foot'
}, {
  key: 3,
  value: 'Cubic Yard',
  text: 'Cubic Yard'
}, {
  key: 4,
  value: 'Day',
  text: 'Day'
}, {
  key: 5,
  value: 'Each',
  text: 'Each'
}, {
  key: 6,
  value: 'Foot',
  text: 'Foot'
}, {
  key: 7,
  value: 'Hour',
  text: 'Hour'
}, {
  key: 8,
  value: 'Inch',
  text: 'Inch'
}, {
  key: 9,
  value: 'Linear Foot',
  text: 'Linear Foot'
}, {
  key: 10,
  value: 'Mile',
  text: 'Mile'
}, {
  key: 11,
  value: 'Million Board Feet',
  text: 'Million Board Feet'
}, {
  key: 12,
  value: 'Square Foot',
  text: 'Square Foot'
}, {
  key: 13,
  value: 'Square Yard',
  text: 'Square Yard'
}, {
  key: 14,
  value: 'Square Foot per inch',
  text: 'Square Foot per inch'
}, {
  key: 15,
  value: 'Ton',
  text: 'Ton'
}];
exports.UNIT_OF_MEASURE_TYPES = UNIT_OF_MEASURE_TYPES;
var activityTier = [{
  key: 1,
  value: 'Primary activity',
  text: 'Primary activity type',
  subText: 'Primary sub-activity types',
  tier: 'primary'
}, {
  key: 2,
  value: 'Secondary activity',
  text: 'Secondary activity type',
  subText: 'Secondary sub-activity types',
  tier: 'secondary'
}, {
  key: 3,
  value: 'Tertiary activity',
  text: 'Tertiary activity type',
  subText: 'Tertiary sub-activity types',
  tier: 'tertiary'
}, {
  key: 4,
  value: 'Quarternary activity',
  text: 'Quarternary activity type',
  subText: 'Quarternary sub-activity types',
  tier: 'quarternary'
}, {
  key: 5,
  value: 'Quinary activity',
  text: 'Quinary activity type',
  subText: 'Quinary sub-activity types',
  tier: 'quinary'
}];
exports.activityTier = activityTier;
var HOLIDAYS = [
// 2019
'01-01-2019',
// New Year's Day
'01-21-2019',
// Martin Luther King Jr. Day
'02-18-2019',
// Washington's Birthday
'05-27-2019',
// Memorial Day
'07-04-2019',
// Independence Day
'09-02-2019',
// Labor Day
'10-14-2019',
// Columbus Day
'11-11-2019',
// Veterans Day
'11-28-2019',
// Thanksgiving
'12-25-2019',
// Christmas Day

// 2020
'01-01-2020',
// New Year's Day
'01-20-2020',
// Martin Luther King Jr. Day
'02-17-2020',
// Washington's Birthday
'05-25-2020',
// Memorial Day
'07-03-2020',
// Independence Day
'09-07-2020',
// Labor Day
'10-12-2020',
// Columbus Day
'11-11-2020',
// Veterans Day
'11-26-2020',
// Thanksgiving
'12-24-2020',
// Christmas Eve
'12-25-2020',
// Christmas Day

// 2021
'01-01-2021',
// New Year's Day
'01-18-2021',
// Martin Luther King Jr. Day
'01-20-2021',
// Inauguration Day Holiday* (depends on year)
'02-15-2021',
// Washington's Birthday
'05-31-2021',
// Memorial Day
'07-05-2021',
// Independence Day
'09-06-2021',
// Labor Day
'10-11-2021',
// Columbus Day
'11-11-2021',
// Veterans Day
'11-25-2021',
// Thanksgiving
'12-24-2021' // Christmas Day
];
exports.HOLIDAYS = HOLIDAYS;
var GRANT_ROSTER_FIELDS = {
  NAME: 'name',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  COMMENTS: 'comments',
  POSITION_ID: 'positionId',
  ROSTER_ID: 'rosterId',
  EMPLOYEES: 'employees',
  POSITIONS: 'positions',
  NOT_FUNDED: 'notFunded'
};
exports.GRANT_ROSTER_FIELDS = GRANT_ROSTER_FIELDS;
var YES_NO_RADIO_OPTIONS = [{
  label: 'Yes',
  value: true
}, {
  label: 'No',
  value: false
}];
exports.YES_NO_RADIO_OPTIONS = YES_NO_RADIO_OPTIONS;
var profilePhoneNumberOptions = [{
  key: 'default',
  value: '',
  text: ''
}, {
  key: 1,
  value: 6,
  text: 'Mobile'
}, {
  key: 2,
  value: 10,
  text: 'Work'
}, {
  key: 3,
  value: 4,
  text: 'Home'
}, {
  key: 4,
  value: 11,
  text: 'Fax'
}, {
  key: 5,
  value: 7,
  text: 'Other'
}];
exports.profilePhoneNumberOptions = profilePhoneNumberOptions;
var phoneNumberOptions = [{
  key: 1,
  value: 'M',
  text: 'Mobile'
}, {
  key: 2,
  value: 'W',
  text: 'Work'
}, {
  key: 3,
  value: 'H',
  text: 'Home'
}, {
  key: 4,
  value: 'X',
  text: 'Fax'
}, {
  key: 5,
  value: 'O',
  text: 'Other'
}];
exports.phoneNumberOptions = phoneNumberOptions;
var ALWAYS_DIRTY_MAP = {
  dirtyPage: true,
  dirty: true
};
exports.ALWAYS_DIRTY_MAP = ALWAYS_DIRTY_MAP;
var MAILING_ADDRESS = 'mailingAddress';
exports.MAILING_ADDRESS = MAILING_ADDRESS;
var SHOW_HIDE = 'ShowHide';
exports.SHOW_HIDE = SHOW_HIDE;
var CAN_SUBMIT = 'canSubmit';
exports.CAN_SUBMIT = CAN_SUBMIT;
var CAN_SUBMIT_POSITIVE = 'canSubmitPositive';
exports.CAN_SUBMIT_POSITIVE = CAN_SUBMIT_POSITIVE;
var SECTION_RESULTS = 'sectionResults';
exports.SECTION_RESULTS = SECTION_RESULTS;
var PART_RESULTS = 'partResults';
exports.PART_RESULTS = PART_RESULTS;
var FACTOR_RESULTS = 'factorResults';
exports.FACTOR_RESULTS = FACTOR_RESULTS;
var ERROR = 'error';
exports.ERROR = ERROR;
var JUSTIFICATION = 'justification';
exports.JUSTIFICATION = JUSTIFICATION;
var SCORE = 'score';

/**
 * specifes range of return values expected by checkActivityCompleted() when it calls checkActivityCompleted()
 */
exports.SCORE = SCORE;
var ACTIVITY_RESPONSES = {
  active: 'active',
  ended: 'ended'
};
exports.ACTIVITY_RESPONSES = ACTIVITY_RESPONSES;
var COOKIES = {
  BANNERREPORT: 'bannerReport',
  LOGINGOVUSER: 'loginGovUser',
  LOGINGOVERROR: 'loginGovError'
};
exports.COOKIES = COOKIES;
var GRANT_ACTIONS_REQUIRED_TOGGLES = [];
exports.GRANT_ACTIONS_REQUIRED_TOGGLES = GRANT_ACTIONS_REQUIRED_TOGGLES;
var TOGGLE_REDUX_PATH = 'toggles';
exports.TOGGLE_REDUX_PATH = TOGGLE_REDUX_PATH;
var TOGGLE_ERROR = 'toggleError';
exports.TOGGLE_ERROR = TOGGLE_ERROR;
var TOGGLE_LOADING = 'toggleLoading';
exports.TOGGLE_LOADING = TOGGLE_LOADING;
var TOGGLE_SUCCESS = 'toggleSuccess';
exports.TOGGLE_SUCCESS = TOGGLE_SUCCESS;
var TOKEN_LOADED = 'tokenLoaded';
exports.TOKEN_LOADED = TOKEN_LOADED;
var TOKEN_LOADING = 'tokenLoading';
exports.TOKEN_LOADING = TOKEN_LOADING;
var RECRUITMENT_AND_RETENTION = 'recruitmentAndRetention';
exports.RECRUITMENT_AND_RETENTION = RECRUITMENT_AND_RETENTION;
var HIRING_OF_FIREFIGHTERS = 'hiringOfFirefighters';
exports.HIRING_OF_FIREFIGHTERS = HIRING_OF_FIREFIGHTERS;
var SUB_AWARD_REC_INDX_ERROR = 'context.subAwardRecommendationsForGrant.payload.${index}.payload.budget.totalAmount';
exports.SUB_AWARD_REC_INDX_ERROR = SUB_AWARD_REC_INDX_ERROR;
var email_regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
exports.email_regex = email_regex;